import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPromotionBanners } from '../../store/actions/general.actions';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import NewLoading from '../../Components/Common/NewLoading';
import { Translate } from '../../localization';

const PromotionItem = () => {

    const { slug } = useParams();
    const dispatch = useDispatch();
    const { promotionBanners, promotionBannersLoading } = useSelector((state) => state.general);

    useEffect(() => {
        dispatch(getPromotionBanners());
        const canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.setAttribute(
                'href',
                `https://www.jackpotct.com/${Translate.getLanguage()}/d/promotion/${slug}`
            );
        }
    }, []);

    const data = promotionBanners.filter((item) => item.slug === slug);

    return (promotionBannersLoading ?
        <NewLoading customClass="min-height-loader" />
        : <div id='scrollableDiv'>
            <div className='promotion-extra-details'>
                <div className='promotion-category-header'>
                    <img className='mob-promotion-image' src={data[0]?.vimage_urls} width='100%' />
                    <img className='desktop-promotion-image' src={data[0]?.image_urls} width='100%' />
                    <h1 className='mb-2'> {data[0]?.title} </h1>
                </div>
                <div className='promotion-category-description'>
                    <div className='promotion-details' dangerouslySetInnerHTML={{ __html: data[0]?.content }} />
                </div>
            </div>
        </div>
    );
};

export default PromotionItem;